/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentPermissionDetail {
    getFixupPrototypeFunction() { return AwsSsmDocumentPermissionDetail.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentPermissionDetail>): AwsSsmDocumentPermissionDetail {
        let obj = Object.assign(new AwsSsmDocumentPermissionDetail(), model);
        AwsSsmDocumentPermissionDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentPermissionDetail>): AwsSsmDocumentPermissionDetail {
        if (!model) return null;
        return AwsSsmDocumentPermissionDetail.newInstance(<AwsSsmDocumentPermissionDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentPermissionDetail) {
        if (!obj) return;

        models.AwsSsmDocumentPermissionDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentPermissionDetail): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocumentPermissionDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.account_sharing_info) {
            for (let val of this.account_sharing_info) {
                models.AwsSsmDocumentAccountShared.fixupPrototype(val);
            }
        }
    }

    /**
     * AWS account ids
     */
    account_ids: Array<string>;

    /**
     * AWS account details
     */
    account_sharing_info: Array<models.AwsSsmDocumentAccountShared>;

}
